// extracted by mini-css-extract-plugin
export default {"primary":"#2EC4B6","secondary":"#dedede","success":"#3bc862","info":"rgba(4,170,89,0.301961)","warning":"#edaa21","danger":"#d10d0d","light":"#e3eaef","dark":"#5a5a5a"};